"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiView = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var KpiExecutor_1 = require("./KpiExecutor");
var contexts_1 = require("../../contexts");
var internal_1 = require("../../hooks/internal");
/**
 * Takes a KPI widget and executes it and displays the result.
 * @internal
 */
exports.KpiView = function (_a) {
    var dashboardRef = _a.dashboardRef, kpiWidget = _a.kpiWidget, alert = _a.alert, filters = _a.filters, onFiltersChange = _a.onFiltersChange, filterContext = _a.filterContext, drillableItems = _a.drillableItems, onDrill = _a.onDrill, onError = _a.onError, backend = _a.backend, workspace = _a.workspace, _b = _a.ErrorComponent, ErrorComponent = _b === void 0 ? sdk_ui_1.ErrorComponent : _b, _c = _a.LoadingComponent, LoadingComponent = _c === void 0 ? sdk_ui_1.LoadingComponent : _c;
    ts_invariant_1.default(kpiWidget.kpi, "The provided widget is not a KPI widget.");
    var _d = internal_1.useKpiData({
        kpiWidget: kpiWidget,
        backend: backend,
        filters: filters,
        filterContext: filterContext,
        workspace: workspace,
        onError: onError,
    }), error = _d.error, result = _d.result, status = _d.status;
    var config = contexts_1.useDashboardViewConfig();
    var isReadOnly = contexts_1.useDashboardViewIsReadOnly();
    if (status === "loading" || status === "pending") {
        return react_1.default.createElement(LoadingComponent, null);
    }
    if (status === "error") {
        return react_1.default.createElement(ErrorComponent, { message: error.message });
    }
    return (react_1.default.createElement(KpiExecutor_1.KpiExecutor, { dashboardRef: dashboardRef, kpiWidget: kpiWidget, primaryMeasure: result.primaryMeasure, secondaryMeasure: result.secondaryMeasure, alert: alert, allFilters: result.allFilters, effectiveFilters: result.effectiveFilters, onFiltersChange: onFiltersChange, onDrill: onDrill, onError: onError, drillableItems: drillableItems, separators: config === null || config === void 0 ? void 0 : config.separators, disableDrillUnderline: config === null || config === void 0 ? void 0 : config.disableKpiDrillUnderline, backend: backend, workspace: workspace, ErrorComponent: ErrorComponent, LoadingComponent: LoadingComponent, isReadOnly: isReadOnly }));
};
//# sourceMappingURL=index.js.map